import { createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/question.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-dbb9e982")

_pushScopeId("data-v-dbb9e982")
const _hoisted_1 = { class: "_clickBlocker" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "d-flex justify-content-around mt-4" }
const _hoisted_4 = { class: "fs_14 white" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "genericModalContent text-center",
      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent","stop"]))
    }, [
      _hoisted_2,
      _createVNode("span", {
        class: "message",
        innerHTML: _ctx.text,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.textClicked()))
      }, null, 8, ["innerHTML"]),
      _createVNode("div", _hoisted_3, [
        _createVNode("button", {
          type: "button",
          class: "genericButton w-50",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ko && _ctx.ko(...args)))
        }, [
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.noButton), 1)
        ]),
        _createVNode("button", {
          type: "button",
          class: "genericButton bgWhite w-50",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args)))
        }, _toDisplayString(_ctx.yesButton), 1)
      ])
    ])
  ]))
})